module.exports = __webpack_public_path__ + "img/only_you.9971d43e.png";